import React, { useMemo } from 'react';
import { Col, Form, Select } from 'antd';
import { useQuery } from '@common/hooks';
import {
  SHIFT_GAP_TAGS_QUERY,
  ShiftGapTagsResponse,
} from '@scheduling/graphql';

interface ShiftTagSelectProps {
  defaultValue?: string[] | undefined;
}

export const ShiftTagSelect = ({ defaultValue }: ShiftTagSelectProps) => {
  const { data: tagsData, loading: tagsLoading } =
    useQuery<ShiftGapTagsResponse>(SHIFT_GAP_TAGS_QUERY);

  const shiftGapTagToOptions = useMemo(() => {
    return tagsData?.shiftGapTags?.map((tag) => ({
      label: tag.name,
      value: tag.id,
    }));
  }, [tagsData]);

  if (!tagsData?.shiftGapTags?.length) {
    return null;
  }

  return (
    <Col span={24}>
      <Form.Item name="shiftGapTagIds" label="Tags">
        <Select
          mode="multiple"
          filterOption={(input, option) => {
            return option
              ? option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
              : false;
          }}
          options={shiftGapTagToOptions}
          placeholder="Select tags"
          size="large"
          loading={tagsLoading}
          defaultValue={defaultValue}
        />
      </Form.Item>
    </Col>
  );
};
